export default __webpack_public_path__ + "images/rosabandet/circle-blue-blur.svg";